<template>
  <div class="page flex componentPage">
        <div v-if='look'>
            <el-col :span='4' style='margin-top:-20px;margin-bottom:10px'>
                <el-button type="primary" @click="add" size='small' icon='el-icon-circle-plus-outline'>新增回访记录</el-button>
            </el-col>
            <el-table :data='dataList' border height="100%" max-height="500px" style='min-height:300px;'>
                <el-table-column type='index' label='序号' width='80'></el-table-column>
                <el-table-column prop="mobile_status" label="手机状态"/>
                <el-table-column prop="visit_cause" label="回访原因"/>
                <!-- <el-table-column prop="creator" label="创建人"/> -->
                <el-table-column prop="roleName" label="回访时间">
                    <template v-slot='{row}'>
                        {{$date.format(row.create_date, "YYYY-MM-DD HH:mm:ss")}}
                    </template>
                </el-table-column>
                <el-table-column prop="visit_result" label="回访结果"/>
                <el-table-column prop="user_name" label="回访人"/>
            </el-table>
                <el-dialog :title='title' :visible.sync="visible" width="500px">
                <user-info :params='params' :close='close'/>
            </el-dialog>
        </div>
        <div v-else>
            <add-return-visit @back='back'/>
        </div>
  </div>
</template>

<script>
import addReturnVisit from '@/components/addReturnVisit.vue'
import { store } from '@/util/observable.js'
  export default {
    data () {
      return {
          form: {},
          dataList: [],
          title: '新增用户',
          visible: false,
          params: {},
          roleNames: [],
          current:1,
          total:0,
          look:true
      }
    },
    components: {
        addReturnVisit
    },
   methods: {
       async getUser(){
           let params = {
               userId: store.userId
           }
           const rsp = await this.$http.visitRecord(params)
           if(rsp.code != 200) return
           this.dataList = rsp.data.records
       },
       
       close(){
           this.visible = false
           this.getUser()
       },
       add(){
           this.look = false
       },
       back(val){
           this.look = true
           if(val) this.getUser()
       }
   },
   created(){
       this.getUser()
   }
    }
</script>

<style scoped >
.page{flex-direction: column;}
 
</style>
